export type Month = "jan"|"feb"|"mar"|"apr"|"may"|"jun"|"jul"|"aug"|"sep"|"oct"|"nov"|"dec"
export type Year = number

const months: Month[] = [ "jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec" ]
export const monthToJsMonthNumber = (m: Month) => months.indexOf(m)
export const monthToNumber = (m: Month) => monthToJsMonthNumber(m) + 1
export const numberToMaybeMonth = (i: number) => months[i - 1]
export const stringToMaybeMonth = (s: string): Month|undefined => months.find(a => a === s)
export const monthToUserString = (m: Month) => {
	switch (m) {
		case 'jan': return 'January'
		case 'feb': return 'February'
		case 'mar': return 'March'
		case 'apr': return 'April'
		case 'may': return 'May'
		case 'jun': return 'June'
		case 'jul': return 'July'
		case 'aug': return 'August'
		case 'sep': return 'September'
		case 'oct': return 'October'
		case 'nov': return 'November'
		case 'dec': return 'December'
	}
	throw `invalid month ${m}`
}



// WEBPACK FOOTER //
// ./src/lib/date-utils.ts